// https://vuex.vuejs.org/en/state.html

export default {
    token: JSON.parse(localStorage.getItem("token")) || null,
    isLogin: false,
    isEditDialogShow: false,
    loggedUser: {},
    sexitems: [
        {
            text: "ذكر",
            value: 0,
        },
        {
            text: "انثى",
            value: 1,
        },
    ],
    pregages: ["اكبر من ٣٧ اسبوع", "اصغر من ٣٧ اسبوع"],
    appRules: {
        nameRules: [v => !!v || "هذا الحقل مطلوب", v => v.length > 1 || "الحروف المدخلة قليلة"],
        barcodenumberRules: [
            v => !!v || "هذا الحقل مطلوب",
            v => v.length >= 6 || "الرقم المدخل غير صحيح",
        ],
        numberRules: [v => !!v || "هذا الحقل مطلوب", v => v.length >= 1 || "الرقم المدخل غير صحيح"],
        dateRules: [v => !!v || "هذا الحقل مطلوب", v => v.length > 8 || "التاريخ المدخل غير صحيح"],
        phoneRules: [
            v => !!v || "حقل رقم الهاتف مطلوب",
            v => v.length > 10 || "رقم الهاتف المدخل غير صحيح",
        ],
        emailRules: [
            v => !!v || "حقل البريد الالكتروني مطلوب",
            v => /.+@.+/.test(v) || "يرجى ادخال بريد الكتروني صحيح",
        ],
    },
    reasons: [
        {
            text: "العينة غير صالحة",
            value: "العينة غير صالحة",
        },
        {
            text: "خطأ في معلومات المراجع",
            value: "خطأ في معلومات المراجع",
        },
        {
            text: "اعادة فحص للتأكيد",
            value: "اعادة فحص للتأكيد",
        },
    ],
    cardstatus: [
        {
            text: "العينات الصالحة فقط",
            value: 0,
        },
        {
            text: "العينات المكررة",
            value: 1,
        },
        {
            text: "العينات المرفوضة",
            value: 2,
        },
        {
            text: "العينات المكررة و المرفوضة",
            value: 3,
        },
        {
            text: "العينات الصالحة و المكررة و المرفوضة",
            value: 4,
        },
    ],
    disease: [
        {
            text: "CHT",
            value: 1,
        },
        {
            text: "PKU",
            value: 2,
        },
        {
            text: "GAO",
            value: 3,
        },
    ],
    checktypes: [
        {
            text: "الجميع",
            value: "",
        },
        {
            text: "Screening غربلة",
            value: 1,
        },
        {
            text: "Follow up متابعة",
            value: 2,
        },
        {
            text: "Outpatient طلب خارجي",
            value: 3,
        },
        {
            text: "Confirmation توكيدي",
            value: 4,
        },
    ],
    iraqprovs: [
        {
            text: "بغداد",
            value: 0,
        },
        {
            text: "كربلاء",
            value: 1,
        },
        {
            text: "الأنبار",
            value: 2,
        },
        {
            text: "بابل",
            value: 3,
        },
        {
            text: "البصرة",
            value: 4,
        },
        {
            text: "أربيل",
            value: 5,
        },
        {
            text: "دهوك",
            value: 6,
        },
        {
            text: "واسط",
            value: 7,
        },
        {
            text: "القادسية",
            value: 8,
        },
        {
            text: "ديالى",
            value: 9,
        },
        {
            text: "ذي قار",
            value: 10,
        },
        {
            text: "السليمانية",
            value: 11,
        },
        {
            text: "صلاح الدين",
            value: 12,
        },
        {
            text: "كركوك",
            value: 13,
        },
        {
            text: "المثنى",
            value: 14,
        },
        {
            text: "ميسان",
            value: 15,
        },
        {
            text: "النجف",
            value: 16,
        },
        {
            text: "نينوى",
            value: 17,
        },
    ],
};
